import { Box, useMediaQuery, useTheme } from "@mui/material";

interface ShortcutButtonProps {
  label: string;
  variant?: "light" | "dark";
}

export default function ShortcutButton({
  label,
  variant = "light",
}: ShortcutButtonProps) {

  const theme = useTheme();

  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  if (!isDesktop) return null; 

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          variant === "dark" ? "#d6d6f8" : "#e9e9ef",
        borderRadius: "4px",
        px: "6px",
        fontSize: "10px",
        fontWeight: 500,
        border: `${variant === "dark" ? "0px solid #ffffff" : "1px solid #d4d4d4"}`,
        color: theme.palette.primary.main,
        mr: 1,
      }}
    >
      {label.toUpperCase()}
    </Box>
  );
}